<template>
  <transition name="fade">
    <div class="message-box" v-if="isShowFirstTimeMessage">
      <div class="content">
        {{ $t("autoIndentConfirmationDialog.message") }}
      </div>
      <div class="nav">
        <button class="button" @click="close">{{ $t("common.close") }}</button>
      </div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="arrow-svg"
        width="50"
        height="20"
        viewBox="0 0 50 20"
        style="background-color: transparent"
      >
        <polyline points="0,20 50,0 50,20" />
      </svg>
    </div>
  </transition>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    title: String,
    content: String,
  },
  computed: {
    isShowFirstTimeMessage() {
      return this.$store.getters["manuscriptModule/isShowingAutoIndentFirstTimeMessage"];
    },
  },
  methods: {
    close() {
      this.$store.dispatch("manuscriptModule/closeAutoIndentMessage");
    },
  },
});

interface Props {
  title: string;
  content: string;
}

interface Data {}

interface Computed {
  isShowFirstTimeMessage: boolean;
}

interface Methods {
  close(): void;
}
</script>

<style lang="scss" scoped>
@import "@/style-common.scss";

.message-box {
  position: absolute;
  top: 80px;
  right: 10px;
  width: 280px;
  height: 120px;
  padding: 16px;
  background-color: var(--color-background-normal);
  border: 2px solid var(--color-border);
  box-shadow: var(--shadow-md);
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .content {
    border: none;
    padding: none;
    font-size: 1.3em;
    font-weight: var(--font-weight-bold);
    color: var(--color-text-normal);
  }

  .nav {
    display: flex;
    justify-content: right;
    width: 100%;

    .button {
      background: none;
      border: none;
      padding: 5px;
      margin: 0;
      text-decoration: underline;
      text-align: right;
      cursor: pointer;
      color: var(--color-text-normal);

      &:hover {
        color: var(--color-primary);
      }
    }
  }

  .arrow-svg {
    position: absolute;
    top: -20px;
    right: 10px;
    stroke-width: 2;
    fill: var(--color-background-normal);
    stroke: var(--color-border);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.8s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
